export default /* @ngInject */ function ($routeProvider) {

    $routeProvider.when('/activate/key/:key', {
        templateUrl: '/activate/activate/activate.html',
        controller: 'ActivateAccountCtrl',
        controllerAs: 'activate',
        title: 'Activate your account'
    });

    $routeProvider.when('/activate/invalid', {
        templateUrl: '/activate/invalid/invalid.html',
        title: 'Something went wrong'
    });

    $routeProvider.when('/activate/resend', {
        templateUrl: '/activate/resend/resend.html',
        controller: 'ActivateResendCtrl',
        controllerAs: 'activation',
        title: 'Resend activation email'
    });

    $routeProvider.when('/activate/confirmation', {
        templateUrl  : '/activate/confirmation/confirmation.html',
        controller   : 'ActivateConfirmationCtrl',
        controllerAs : 'activateConfirmation',
        title        : 'Account activated'
    });
}



// WEBPACK FOOTER //
// ./activate/activate-routes.js